import React, { useEffect, useState } from "react";
import Dropzone from "react-dropzone";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { PrevIcon } from "../../Icon";
import { BlobServiceClient } from "@azure/storage-blob";
import { Loader } from "../../commons";
import { UploadIcon } from "../../../assets/images";
import "../../../components/commons/Upload/upload.scss";
import { UploadFileTypesPayload } from "../../../commonTypes/fileManagerTypes";
import {
  Files
} from "../../FileManager";
import { useFolder } from "../../../customHooks/FileManager/useFolder";
import { childFolderType } from "../../../redux/fileManager/fileManagerTypes";
import { folderType } from "../../../customHooks/FileManager/useFolderTypes";
import RenderFileManager from "./RenderFileManager";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/rootReducers";

type AppProps = {
  type?: string;
  toggleModal: () => void;
  fetching?: boolean;
  modal?: boolean;
  client_code?: number | string | any;
  token?: string | null;
  handleUploadFile: (
    data: UploadFileTypesPayload[] | UploadFileTypesPayload
  ) => void;
  handleUploadFileFromFileManager?: (data: any) => void;
  setShowFileUploadModal?: (data: boolean) => void;
  isDraggableModal?: boolean;
  acceptedFiles?: string;
  supportedFiles?: string;
  maxFileSize?: number;
  setUploadData: (data: any) => void;
  uploadData: any;
  isEdit?: boolean;
  isDropZone:boolean;
};

export type singleFolderDataType = {
  folder_id: string;
  folder_data: folderType | null;
};

const UploadModalWithFileManager = ({
  type,
  toggleModal,
  modal,
  client_code,
  acceptedFiles,
  supportedFiles,
  maxFileSize,
  fetching,
  isEdit,
  handleUploadFile,
  setShowFileUploadModal,
  handleUploadFileFromFileManager,
  isDraggableModal,
  setUploadData,
  uploadData,
  isDropZone
}: AppProps) => {
  const [fileNames, setFileNames] = useState<any>([]);
  const [isFileManagerVisible, setIsFileManagerVisible] =
    useState<boolean>(false);
  const [fileData, setFileData] = useState<string>("");
  const [multipleFileData, setMultipleFileData] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [folderData, setFolderData] = useState<childFolderType[]>([]);
  const [filesData, setFilesData] = useState<any>([]);
  const [persistFolderData, setPersistFolderData] = useState<any>([]);
  const [singleFolderData, setSingleFolderData] =
    useState<singleFolderDataType>(() => ({
      folder_id: "0",
      folder_data: null,
    }));
  const [checkingBack, setCheckingBack] = useState<boolean>(true);
  const [flag, setFlag] = useState<boolean>(false);
  const [isFileManagerOptions, setIsFileManagerOptions] = useState(true);
  const [isDropZoneVisible, setIsDropZoneVisible] = useState(true);

  let blobBaseUrl = process.env.REACT_APP_BLOB_BASE_URL;
  let blobToken = process.env.REACT_APP_BLOB_TOEKN;

  let blobSasUrl = `${blobBaseUrl}?${blobToken}`;

  const blobServiceClient = new BlobServiceClient(blobSasUrl);
  const containerName = `clientcontainer${client_code}`;
  const containerClient = blobServiceClient.getContainerClient(containerName);

  const removeDuplicate = (data: any) => {
    let nonRepeatData: any = new Set();

    data?.forEach(
      (obj: any) =>
        !nonRepeatData.has(JSON.stringify(obj)) &&
        nonRepeatData.add(JSON.stringify(obj))
    );

    let finalData: any = new Set(
      [...nonRepeatData].map((item) => JSON.parse(item))
    );
    return finalData;
  };

  let finalPersistData: any = Array.from(removeDuplicate(persistFolderData));
  const currentFolderDetails = useSelector(
    (state: RootState) => state.fileManager.currentFolderDetails
  );
  // Custom hook call
  const { childFolders, childFiles, folder }: any = useFolder(
    checkingBack
      ? singleFolderData?.folder_id
      : finalPersistData?.length > 1
      ? finalPersistData[finalPersistData.length - 1].id
        ? finalPersistData[finalPersistData.length - 1].id
        : "0"
      : "0",
    checkingBack
      ? finalPersistData?.folder_data
      : finalPersistData?.length > 0
      ? finalPersistData[finalPersistData.length - 1].folder_data
      : null,
    client_code
  );

  useEffect(() => {
    if (
      (type === "editinvoice" || type === "copyInvoice") &&
      uploadData?.column_value?.length > 0
    ) {
      setMultipleFileData([...uploadData?.column_value]);
    } else if (uploadData?.length > 0) {
      setMultipleFileData([...uploadData]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  useEffect(()=>{
   if(!isDropZone){
    setMultipleFileData([...uploadData])
    setIsFileManagerVisible(true)
   }
   // eslint-disable-next-line react-hooks/exhaustive-deps
  },[isDropZone])

  useEffect(()=>{
    if(!isDropZone){
      setUploadData([...multipleFileData])
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[multipleFileData])

  useEffect(() => {
    if (multipleFileData?.length == 0) {
      setIsDropZoneVisible(true);
    }
  }, [multipleFileData]);

  useEffect(() => {
    if (childFolders?.length > 0) {
      setFolderData([...childFolders]);
    }

    if (childFolders?.length === 0) {
      setFolderData([]);
    }

    if (childFiles?.length === 0) {
      setFilesData([]);
    }
  }, [childFolders, childFiles]);

  const handleDrop = (acceptedFiles: any[string]) => {
    setFileNames([...acceptedFiles?.map((file: { name: any }) => file?.name)]);
    setFileData(acceptedFiles);
    setIsFileManagerOptions(false);
  };

  const fileUpload = (e: any) => {
    setLoading(true);
    handleUploadFileFromFileManager &&
      handleUploadFileFromFileManager(multipleFileData);
    uploadFiles(fileData);
  };

  const handleCancelFileManager = () => {
    if (uploadData?.column_value) {
      setMultipleFileData([...uploadData?.column_value]);
      setFileNames([
        ...uploadData?.column_value?.map((item: any) => item?.file_name),
      ]);
    } else if (uploadData) {
      setMultipleFileData([...uploadData]);
      setFileNames([...uploadData?.map((item: any) => item?.file_name)]);
    } else {
      setMultipleFileData([]);
      setFileNames([]);
    }
  };

  const uploadFiles = async (uploadedFile: any) => {
    if (uploadedFile?.length == 1 && uploadedFile[0].hasOwnProperty("path")) {
      try {
        let resp;

        const blockBlobClient = containerClient.getBlockBlobClient(
          new Date().valueOf() +
            "." +
            uploadedFile[0].name.split(".")[
              uploadedFile[0].name.split(".").length - 1
            ]
        );

        resp = await blockBlobClient.uploadBrowserData(uploadedFile[0]);

        if (
          resp &&
          resp["_response"] &&
          resp["_response"].status &&
          (resp["_response"].status === 201 || resp["_response"].status === 200)
        ) {
          updateDocumentAPI(
            uploadedFile[0].name,
            blockBlobClient["_name"],
            blockBlobClient["_containerName"],
            uploadedFile[0].type
          );
          setLoading(false);
        } else {
          alert("something wrong");
          setLoading(false);
        }
      } catch (error) {
        setLoading(false);
      }
    } else {
      setShowFileUploadModal && setShowFileUploadModal(false);
    }
  };

  const removingFileData = (fileUrl: any) => {
    let filteredUploadData = multipleFileData?.filter(
      (item: any) => item.file_url != fileUrl
    );
    setMultipleFileData([...filteredUploadData]);
  };

  const settingGoBack = (fileUrl: any) => {
    setFlag(true);
    setCheckingBack(false);
    let newData = JSON.parse(JSON.stringify(finalPersistData));
    newData.pop();

    if (currentFolderDetails?.name == "Home" && !checkingBack) {
      setIsFileManagerVisible(false);
      handleCancelFileManager();
    } else {
      setSingleFolderData({
        folder_id: finalPersistData[finalPersistData?.length - 1]?.parent_id,
        folder_data: newData?.length > 0 ? newData[newData?.length - 1] : null,
      });
    }

    setPersistFolderData([...newData]);
  };

  const updateDocumentAPI = (
    file_name: string,
    url_name: string,
    url_container: string,
    file_type: string
  ) => {
    let data: UploadFileTypesPayload = {
      file_name,
      file_url: url_container + "/" + url_name,
      file_type,
    };
    handleUploadFile?.([...multipleFileData, data]);
  };

  const UploadFileManager = () => {
    setIsFileManagerVisible(true);
  };

  const handleUploadInvoiceFile = (
    file_name: string,
    file_url: string,
    file_type: string
  ) => {
    let data: UploadFileTypesPayload = {
      file_name,
      file_url,
      file_type,
    };

    handleUploadFile?.(data);
  };

  const renderDraggableUpload = () => {
    return (
      <div>
        {isDropZoneVisible && (
          <Dropzone
            accept={
              acceptedFiles ??
              "image/png, image/gif, application/pdf, image/jpeg, .csv, text/csv, application/vnd.ms-excel, application/csv, text/x-csv, application/x-csv, text/comma-separated-values, text/x-comma-separated-values, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/msword"
            }
            minSize={0}
            maxSize={maxFileSize ?? maxSize}
            onDrop={handleDrop}
            multiple={false}
          >
            {({
              getRootProps,
              getInputProps,
              isDragActive,
              isDragReject,
              fileRejections,
            }) => {
              let isFileTooLarge;
              if (maxFileSize) {
                isFileTooLarge = fileRejections[0]?.file?.size > maxFileSize;
              } else {
                isFileTooLarge = fileRejections[0]?.file?.size > maxSize;
              }

              return (
                <div
                  {...getRootProps({
                    className: "dropzone drop-area text-center",
                  })}
                >
                  <input {...getInputProps()} />
                  <img src={UploadIcon} alt="upload"/>

                  {isDragActive && !isDragReject && (
                    <h4 className="text-center">Drop it like it's hot!</h4>
                  )}

                  {isDragReject && (
                    <h4 className="text-center">
                      File type not accepted, sorry!
                    </h4>
                  )}

                  {!isDragActive && (
                    <h4 className="text-center">
                      Drag'n'drop files, or click to select files
                    </h4>
                  )}
                  <p className="text-muted text-center">
                    {`Supported formats: ${
                      supportedFiles ?? "images, PDF, excel and doc."
                    }`}{" "}
                  </p>
                  <p className="text-center text-muted ">
                    {`Single file upload with maximum of ${displayFileSize} MB file size supported.`}
                  </p>
                  {isFileTooLarge && (
                    <div className="text-danger mt-2">File is too large.</div>
                  )}
                </div>
              );
            }}
          </Dropzone>
        )}

        {isFileManagerOptions && (
          <>
            {isDropZoneVisible && <h4 className="text-center mt-3">OR</h4>}

            <h4
              className="text-center p-3"
              style={{
                border: "1px dotted #aaa",
                backgroundColor: "#eee",
                borderRadius: "4px",
                cursor: "pointer",
              }}
              onClick={() => {
                UploadFileManager();
              }}
            >
              Upload From File Manager
            </h4>
          </>
        )}

        <div>
          <ul className="list-group mt-1">
            {fileNames && fileNames.length
              ? fileNames.map((item: any) => (
                  <li
                    className="list-group-item active mt-2"
                    key={item}
                    style={{ wordWrap: "break-word" }}
                  >
                    {item}
                  </li>
                ))
              : null}
          </ul>
        </div>
        <ModalFooter>
          {isDraggableModal && (
            <span
              className="pointer"
              onClick={() => {
                toggleModal && toggleModal();
                handleCancelFileManager();
              }}
            >
              Cancel
            </span>
          )}
          {(fileNames && fileNames?.length) ||
          (multipleFileData && multipleFileData?.length > 0) ? (
            <Button color="primary" onClick={fileUpload}>
              Upload
            </Button>
          ) : null}
        </ModalFooter>
      </div>
    );
  };

  const renderDocumentList = () => {
    let finalDocumentList =
      filesData?.length > 0 &&
      filesData?.map((document: any) => {
        return (
          <Files
            type={"invoice"}
            documentFile={document}
            multipleFileData={multipleFileData}
            setMultipleFileData={setMultipleFileData}
            filesData={filesData}
            setFilesData={setFilesData}
            removingFileData={removingFileData}
            uploadData={uploadData}
            showDeleteIcon={false}
            showViewMoreFiles={false}
            isRenameFilePresent={false}
            handleUploadInvoiceFile={handleUploadInvoiceFile}
          />
        );
      });

    return finalDocumentList;
  };

  const maxSize = 10000000; //10mb file size
  const displayFileSize =
    (maxFileSize && maxFileSize / 1000000) ?? maxSize / 1000000;

  return (
    <>
      {isDraggableModal ? (
        <Modal
          isOpen={modal}
          size={isFileManagerVisible ? "lg" : "x"}
          toggle={toggleModal}
        >
          <ModalHeader toggle={toggleModal}>
            {isFileManagerVisible ? (
              <div
                onClick={() => {
                  settingGoBack(singleFolderData?.folder_data?.id);
                }}
                style={{
                  cursor: "pointer",
                  display: "flex",
                  gap: "8px",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <PrevIcon />
                <div>Selected Files: {multipleFileData?.length}</div>
              </div>
            ) : (
              "File Uploader"
            )}
          </ModalHeader>
          <ModalBody>
            {isFileManagerVisible ? (
              <RenderFileManager
                type={type}
                client_code={client_code}
                folder={folder}
                fetching={fetching}
                flag={flag}
                setFlag={setFlag}
                folderData={folderData}
                renderDocumentList={renderDocumentList}
                filesData={filesData}
                handleUploadFile={handleUploadFile}
                setFilesData={setFilesData}
                childFiles={childFiles}
                setSingleFolderData={setSingleFolderData}
                singleFolderData={singleFolderData}
                setCheckingBack={setCheckingBack}
                checkingBack={checkingBack}
                uploadData={uploadData}
                multipleFileData={multipleFileData}
                setMultipleFileData={setMultipleFileData}
                persistFolderData={finalPersistData}
                setPersistFolderData={setPersistFolderData}
              />
            ) : (
              renderDraggableUpload()
            )}

            {fetching && <Loader />}
            {loading && <Loader />}
          </ModalBody>

          {type && isFileManagerVisible && (
            <ModalFooter>
              <div>
                <button
                  className="btn btn-outline mr-3"
                  onClick={() => {
                    if(isDropZone){
                    setIsFileManagerVisible(false);
                    }else{
                      toggleModal()
                    }
                    setPersistFolderData([]);
                    setSingleFolderData({ folder_id: "0", folder_data: null });
                    handleCancelFileManager();
                  }}
                >
                  Cancel
                </button>
                <button
                  className="btn btn-primary"
                  onClick={() => {
                    multipleFileData?.length && setIsDropZoneVisible(false);
                    if(isDropZone){
                    setIsFileManagerVisible(false);
                    }
                    else{
                      handleUploadFileFromFileManager && handleUploadFileFromFileManager(multipleFileData)
                    }
                    setFileNames([
                      ...multipleFileData?.map((item: any) => item?.file_name),
                    ]);
                  }}
                >
                  Submit
                </button>
              </div>
            </ModalFooter>
          )}
        </Modal>
      ) : (
        renderDraggableUpload()
      )}
    </>
  );
};

export default UploadModalWithFileManager;
